module.exports = __webpack_public_path__ + "files/91e03417731a12e8a3dafe4a3166b186.svg";